import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const PerformanceOverview = ({ participant, evaluation }) => (
  <div className="space-y-4">
    <Card data-testid="overview-participation">
      <CardHeader className="pb-2"><CardTitle className="text-base">Participation</CardTitle></CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
          {[['Position', participant.position], ['Minutes', participant.minutes_played],
            ['Goals', participant.goals_scored], ['Assists', participant.assists],
            ['Yellow', participant.yellow_cards], ['Red', participant.red_cards],
            ['Rating', participant.rating], ['Availability', participant.availability_status]]
            .map(([k, v]) => (
            <div key={k} className="bg-gray-50 rounded-lg p-2.5">
              <p className="text-xs text-gray-400">{k}</p>
              <p className="font-semibold">{v ?? '—'}</p>
            </div>
          ))}
        </div>
        {participant.athlete_notes && (
          <p className="mt-3 text-sm text-gray-600 italic">{participant.athlete_notes}</p>
        )}
      </CardContent>
    </Card>
    <Card data-testid="overview-evaluation">
      <CardHeader className="pb-2"><CardTitle className="text-base">Coach Evaluation</CardTitle></CardHeader>
      <CardContent className="text-sm space-y-2">
        {evaluation ? (
          <>
            {evaluation.overall_rating != null && <p><span className="text-gray-400">Overall rating: </span>{evaluation.overall_rating}</p>}
            {evaluation.strengths && <p><span className="text-gray-400">Strengths: </span>{evaluation.strengths}</p>}
            {evaluation.areas_to_improve && <p><span className="text-gray-400">Areas to improve: </span>{evaluation.areas_to_improve}</p>}
            {evaluation.tactical_notes && <p><span className="text-gray-400">Tactical notes: </span>{evaluation.tactical_notes}</p>}
          </>
        ) : (
          <p className="text-gray-400 py-2" data-testid="overview-no-eval">No coach evaluation recorded for this match.</p>
        )}
      </CardContent>
    </Card>
  </div>
);

export default PerformanceOverview;
